import React from 'react';

function AprGuaranteedDisclaimer() {
    return (
        <div className="panel aprGuaranteedDisclaimer">
            <div className="quote"></div>
            <div className="disclaimer">
                <span>Pool launch information</span>
                <p>
                    {' '}
                    Here are the different sources of revenue that will be injected into the staking:
                    <br />
                    • 33% of deposits lost by users
                    <br />
                    • 5% of our customers' cash inflows
                    <br />
                    • 5% of in-app purchases
                    <br />
                </p>
            </div>
            <img src="assets/images/caracter.png" alt="TADA caracter" />
        </div>
    );
}

export default AprGuaranteedDisclaimer;
